<template>
  <slot />
</template>

<script setup lang="ts">
// This component is responsible of shared, core/low level business logic.
// It should not contain market specific business logic nor any template logic.
import type { VNode } from 'vue'

import { useAddCacheTags } from './composables/useAddCacheTags/useAddCacheTags'
import { useRedirections } from './composables/useRedirections/useRedirections'
import { useSeo } from './composables/useSeo/useSeo'

defineSlots<{
  default: () => VNode
}>()

useRedirections()
useAddCacheTags()
useSeo()
</script>
